/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function isElementVisibleInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
function scrollIntoViewIfNeeded(element) {
  if (!isElementVisibleInViewport(element)) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }
}

function thumbNailNavForMobile() {
  const element = document.querySelector(".flickity-viewport");
  const slideshowNavImages = document.querySelectorAll(
    "#custom-thumbnail-slider__wrapper .Product__SlideshowNavImage"
  );
  const slideShowWrapper = document.getElementById(
    "custom-thumbnail-slider__wrapper"
  );
  const selectedThumbnail = slideShowWrapper.querySelector(
    ".Product__SlideshowNavImage.is-selected"
  );

  // Add a touchstart event listener to respond to the touchend event
  element.addEventListener("touchend", (event) => {
    // Find the closest ancestor with class "flickity-viewport"
    const flickityViewport = event.target.closest(".flickity-viewport");

    // Check if the ancestor element is found
    if (flickityViewport) {
      // Find the nested element with class "Product__SlideItem is-selected"
      const selectedElement = flickityViewport.querySelector(
        ".Product__SlideItem.is-selected"
      );

      // Check if the element is found
      if (selectedElement) {
        var imageDataMediaId = selectedElement.getAttribute("data-media-id");
        slideshowNavImages.forEach(function (thumbnailImage) {
          if (
            thumbnailImage.getAttribute("data-media-id") === imageDataMediaId
          ) {
            thumbnailImage.classList.add("is-selected");
            if (thumbnailImage) {
              const isVisible = isElementVisibleInViewport(thumbnailImage);
              if (!isVisible) {
                scrollIntoViewIfNeeded(thumbnailImage);
              }
            }
          } else {
            thumbnailImage.classList.remove("is-selected");
          }
        });
      }
    }
  });

  // make thumnails is-selected onClick
  slideshowNavImages.forEach(function (image) {
    image.addEventListener("click", function () {
      slideshowNavImages.forEach(function (image) {
        image.classList.remove("is-selected");
      });
      this.classList.add("is-selected");
    });
  });
}

$(document).ready(function () {
  thumbNailNavForMobile();
  const url = window.location.href;

  // Stuff for the Upsell Item on product page
  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    });
  }

  if (url.includes("/products/")) {
    const addUpsellButton = document.getElementById("add-upsell");
    addUpsellButton.addEventListener("click", function () {
      setTimeout(changeText, 100);
      setTimeout(changeBackText, 2000);
      (async () => {
        console.log("start");
        
        const upsellVariantId = document.getElementById("add-upsell").getAttribute("data-variant-id");

        await addItem(upsellVariantId, 1); // add upsell variant
        //window.prepareDataForDisplayWidgetByRule();
        console.log("end");
      })();
    });




 function changeText() {
    if (window.location.pathname.startsWith('/en/')) {
      addUpsellButton.textContent = "Great! 👍";
    } else {
      addUpsellButton.textContent = "Top! 👍";
    }
    addUpsellButton.style.color = "black";
    addUpsellButton.style.background = "white";
    addUpsellButton.style.borderColor = "#f9ca4f";
    addUpsellButton.style.boxShadow = "0 0 10px rgba(255, 215, 0, 0.5)";
  }

  function changeBackText() {
    if (window.location.pathname.startsWith('/en/')) {
      addUpsellButton.textContent = "+";
    } else {
      addUpsellButton.textContent = "+";
    }
    addUpsellButton.style.color = "white";
    addUpsellButton.style.background = "black";
    addUpsellButton.style.borderColor = "white";
    addUpsellButton.style.boxShadow = "none";
  }

  }

  /* this is when you want to add the upsell product via the normal add-to-cart button (checkbox variant)
  
  window.addEventListener('icartAddToCartEvent', function(e){
     const upell_checked = $('#upsell-checkbox_id').is(":checked")
        if (upell_checked == true) {
        
          (async() => {
            console.log('start')
            await addItem(39857604952232, 1) // add upsell variant
            window.prepareDataForDisplayWidgetByRule();
            //icartUpdateCartEvent();
            console.log('end')
          })()
        } else {
           // without adding upsell variant before
        }
  });
  */

  // END - Stuff for the Upsell Item on product page
});


document.addEventListener('DOMContentLoaded', function() {
    // Get the current path and check for language code
    var currentPath = window.location.pathname;
    var languagePrefix = currentPath.split('/')[1]; // Assumes language code is the first segment of the URL

    // Function to update links in the product description
    function updateProductDescriptionLinks() {
        var productDescriptions = document.querySelectorAll('.ProductMeta__Description'); // Select all product description elements

        productDescriptions.forEach(function(productDescription) {
            var links = productDescription.querySelectorAll('a[href^="/products/"]'); // Select all product links within the description

            links.forEach(function(link) {
                var originalHref = link.getAttribute('href');
                // Add language prefix if not already present
                if (!originalHref.startsWith('/' + languagePrefix + '/products/')) {
                    link.setAttribute('href', '/' + languagePrefix + originalHref);
                }
            });
        });
    }

    // Run the updateProductDescriptionLinks function
    updateProductDescriptionLinks();
});


document.addEventListener('DOMContentLoaded', function() {
  // Helper function to format dates as DD.MM
  function formatDateInGerman(date) {
    const dayOfMonth = date.getDate().toString().padStart(2, '0'); // Ensure two digits for the day
    const monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for the month
    return `${dayOfMonth}.${monthNumber}`;
  }

  // Function to add days to a date but skip weekends
  function addWeekdays(startDate, numberOfDaysToAdd) {
    const date = new Date(startDate); // Create a copy of the date
    while (numberOfDaysToAdd > 0) {
      date.setDate(date.getDate() + 1);
      // If it's not Saturday (6) or Sunday (0), decrement the counter
      if (date.getDay() !== 6 && date.getDay() !== 0) {
        numberOfDaysToAdd--;
      }
    }
    return date;
  }

  // Variables for day adjustments
  const daysToAddForFromDate = 1; // Adjust 'fromDate' by weekdays only

  let fromDate = new Date(); // Start with today's date
  fromDate = addWeekdays(fromDate, daysToAddForFromDate);

  const daysToAddForToDate = 3; // Total days to add for 'toDate'
  const toDate = addWeekdays(fromDate, daysToAddForToDate-daysToAddForFromDate);

  // Apply German date formatting (DD.MM)
  document.getElementById('fromDate').innerHTML = formatDateInGerman(fromDate);
  document.getElementById('toDate').innerHTML = formatDateInGerman(toDate);
});

document.addEventListener('DOMContentLoaded', function() {
    // Get elements
    var popupTrigger = document.getElementById('pop-trigger');
    var popupContainer = document.getElementById('pop-container');
    var popupClose = document.getElementsByClassName('pop-close')[0];

    // Open popup when link is clicked
    popupTrigger.onclick = function(event) {
      event.preventDefault();
      popupContainer.style.display = 'block';
    }

    // Close popup when close button is clicked
    popupClose.onclick = function() {
      popupContainer.style.display = 'none';
    }

    // Close popup when clicking outside of the popup content
    window.onclick = function(event) {
      if (event.target == popupContainer) {
        popupContainer.style.display = 'none';
      }
    }
});